import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import TramiteStatusSummaryFiltered from '@/components/TramiteStatusSummary/TramiteStatusSummaryFiltered';
import type { Tramite } from '@/types';

interface TramiteStatusDialogProps {
  tramite: Tramite | null;
  isOpen: boolean;
  onClose: () => void;
}

const TramiteStatusDialog: React.FC<TramiteStatusDialogProps> = ({
  tramite,
  isOpen,
  onClose
}) => {
  if (!tramite) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl max-h-[90dvh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            Estado Detallado - Trámite #{tramite.id}
          </DialogTitle>
          <DialogDescription>
            Visualiza el estado detallado de todos los subtrámites que han sido iniciados.
          </DialogDescription>
        </DialogHeader>
        <div className="mt-4">
          <TramiteStatusSummaryFiltered
            tramite={tramite}
            showOnlyStarted={true}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TramiteStatusDialog;